import React, { FC } from "react";
import EChartsReact from "echarts-for-react";
import { dataEntry, IDataTest } from "../../types/types";

import {
    Paper
} from "@material-ui/core";
import { trafficLight } from "../../theme";


interface IFMChartProps {
    data: IDataTest<dataEntry>
}


const BarLargeChart: FC<IFMChartProps> = ({ data}) => {

    let left = 320

    const height = data.height ? data.height : "250px";


    const data_series = () =>{
    return {
            type: 'bar',
            data: data.data.map((entry, index) => {
                return entry.value[0]
            })
        }
    }



    const getOption = () => {
        // console.log(data.description, "data")
        return {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    // Use axis to trigger tooltip
                    type: 'none' // 'shadow' as default; can also be 'line' or 'shadow'
                },
                backgroundColor: 'rgba(255,255,255,0.7)',
            },
            title: {
                text: data.title,
                left: 'center',
            },
            toolbox: {
                show: true,
                top: 0,
                feature: {
                    saveAsImage: {
                        show: true,
                        pixelRatio: 4
                    },
                    dataView: {
                        show: true,
                        readOnly: false

                    }
                },

            },
            // legend: {
            //     type: 'scroll',
            //     orient: 'vertical',
            //     bottom: 'left',
            //     right: 10
            // },
            label: {
                show: true,
                formatter: function (param: any) {
                    return param.data == 0 ? '' : param.data;
                }
            },

            grid: {
                left: 250,
                right: '20',
                bottom: '60',
                top: '40',
                containLabel: false
            },
            xAxis: {
                type: 'value',
                name: data.axis_label?.x,
                nameGap: 25,
                nameLocation: 'middle',
            },
            yAxis: {
                type: 'category',
                data: data.description
            },
            series: data_series()
        };
    }

    return (<>
            <div style={{ padding: "10px" }}>
                <Paper variant={"outlined"}>
                    <EChartsReact option={getOption()} style={{ height: height }} />
                </Paper>
            </div>

        </>
    );
}

export default BarLargeChart;
